export const network_error_msg = "network error"

export let currencyCode = "CAD"